import script from "./GlobalErrorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalErrorView.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalErrorView.vue?vue&type=style&index=0&id=e17aed8a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e17aed8a"]])

export default __exports__